import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import resources from '../../../services'
import Btn from '../../../ui/Btn'
import { Field } from '../../../ui/Field'
import Select from 'react-select'
import UpdatePage from '../../../composents/UpdatePage'
import { OWNER } from '../Meters/CreateMeter'

const title = 'Group Of Meters'
const headers = {
  icon: 'feather icon-edit',
  title: title,
  description: 'update of group',
  breadcrumbs: [
    {
      title: title,
      link: '/meters/groups',
    },
  ],
}

export default function EditGroupOfMeter() {
  const [loader, setLoader] = useState(false),
    [errors, setErrors] = useState({}),
    [fail, setFail] = useState(false),
    [loading, setLoading] = useState(true),
    { id } = useParams(),
    [data, setData] = useState({}),
    [meters, setMeters] = useState([]),
    [meter, setMeter] = useState(),
    [consumers, setConsumers] = useState(null),
    [consumer, setConsumer] = useState(null),
    [ownership, setOwnership] = useState({
      value: 'Public',
      label: 'Public',
    })

  async function onGet() {
    setLoading(true)
    let gOfMeter = await resources.groupOfMeter
      .readOne(id)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (gOfMeter.status === 200) {
      setData(gOfMeter.data)
      setOwnership({
        label: gOfMeter.data?.ownership,
        value: gOfMeter.data?.ownership,
      })
      if (gOfMeter.data?.ownership === 'Private') {
        try {
          setConsumer({
            label: gOfMeter.data?.consumer?.surname,
            value: gOfMeter.data?.consumer?.id,
          })
        } catch {}
      }
    } else if (gOfMeter.status === 403) {
      setFail(true)
    }

    let meter = await resources.meter
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (meter.status === 200) {
      let a = []
      let b = []
      meter.data.docs.forEach((el) => {
        gOfMeter?.data?.meters?.forEach((element) => {
          if (element === el.id) {
            b.push({
              value: el.id,
              label: el.code,
              group: el._id,
            })
          }
        })

        if (!el.group) {
          a.push({
            value: el.id,
            label: el.code,
            group: el._id,
          })
        }
      })
      setMeters(a)
      setMeter(b)
    }

    let consumers = await resources.consumer
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (consumers.status === 200) {
      let covertToLabelValue = []
      consumers.data.docs.forEach((el) => {
        covertToLabelValue.push({
          value: el.id,
          label: el.surname,
          client: el.client?.id,
        })
      })
      setConsumers(covertToLabelValue)
    }

    setLoading(false)
  }

  useEffect(() => {
    onGet()
  }, [])

  /**
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  async function onCreate(e) {
    e.preventDefault()
    let formData = new FormData(e.target)
    let object = {}
    formData.forEach((value, key) => (object[key] = value))
    setLoader(true)
    setErrors({})
    object.client = data.client?.id
    object.zone = data.zone?.id
    object.ownership = ownership.value
    if (ownership.value === 'Public') {
      object.consumer = null
    }
    if (meter) object.meters = meter.map((e) => e.value)

    let res = await resources.groupOfMeter
      .update(id, object)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      sessionStorage.setItem('success', true)
      window.location.replace('/meters/groups')
    } else if (res.status === 422) {
      setErrors(
        res.data.errors.reduce((acc, error) => {
          return { ...acc, [error.field]: error.message }
        }, {})
      )
    } else if (res.status === 403) {
      setErrors({ not_autorized: true })
    }
    setLoader(false)
  }

  const filterMeter = () => {
    if (data?.zone?.id) {
      return meters.filter((e) => e.zone === data?.zone?.id)
    }

    return []
  }

  const filterConsumers = () => {
    let all_consumers = []

    // if (client) {
    //   all_consumers = consumers.filter((e) => e.client === client.value)
    // }
    return all_consumers
  }

  console.log(consumer)

  return (
    <UpdatePage
      show_error={errors['not_autorized']}
      loading={loading}
      fail={fail}
      headers={headers}
    >
      <form onSubmit={onCreate}>
        <div className="row justify-content-center mt-3 mb-3">
          <div className="col-lg-6 ">
            <div className="card">
              <div className="card-header">
                <h5>Information</h5>
              </div>

              <div className="card-body">
                <Field
                  name="name"
                  className="mb-3"
                  error={errors['client']}
                  disabled
                  defaultValue={data?.client?.name}
                >
                  Client
                </Field>

                <div className="mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Ownership <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Select
                    options={OWNER}
                    isSearchable
                    isClearable={false}
                    value={ownership}
                    onChange={setOwnership}
                    className={errors['ownership'] ? ' is-invalid' : ''}
                  />
                  {errors['ownership'] && (
                    <div className="invalid-feedback">{errors['ownership']}</div>
                  )}
                </div>

                {ownership?.value === 'Private' && (
                  <div className="mb-3">
                    <label htmlFor="exampleInputEmail1" className="form-label">
                      Consumer <span style={{ color: 'red' }}>*</span>
                    </label>
                    <Select
                      options={filterConsumers()}
                      isSearchable
                      isClearable={false}
                      value={consumer}
                      name="consumer"
                      className={errors['consumer'] ? ' is-invalid' : ''}
                    />
                    {errors['consumer'] && (
                      <div className="invalid-feedback">{errors['consumer']}</div>
                    )}
                  </div>
                )}

                <Field
                  name="name"
                  className="mb-3"
                  error={errors['client']}
                  disabled
                  defaultValue={data?.zone?.location}
                >
                  Zone location
                </Field>

                <Field
                  name="name"
                  className="mb-3"
                  error={errors['zone']}
                  disabled
                  defaultValue={data?.zone?.zone}
                >
                  Zone name
                </Field>

                <Field
                  name="name"
                  className="mb-3"
                  error={errors['zone']}
                  required
                  defaultValue={data?.name}
                >
                  Group name
                </Field>

                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Meters <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Select
                    onChange={setMeter}
                    value={meter}
                    options={filterMeter()}
                    isSearchable
                    isClearable
                    isMulti
                  />
                </div>

                <Field
                  name="description"
                  type="textarea"
                  error={errors['description']}
                  className="mb-3"
                >
                  Note
                </Field>

                <div className="row ">
                  <div className="col-lg-12">
                    <div className="d-grid gap-2">
                      <Btn class="btn waves-effect waves-light btn-primary" onLoad={loader}>
                        <i className="feather icon-save"></i> Submit
                      </Btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </UpdatePage>
  )
}
